module.exports = __webpack_public_path__ + "img/turbo-features10.25def116.png";